import styled from 'styled-components';

export const ConditionalWrapper = styled.div`
  height: 100%;
  position: relative;
  /* Keep the back button square beside a long title, as in the designer prototype. */
  & [data-testid='back-button'] {
    flex-shrink: 0;
  }
`;

export const PanelView = styled.div`
  height: 100%;
  &[hidden] {
    display: none;
  }
`;
